import {ethers} from 'ethers';
import {getAccount, getTokenBalance, getWalletBalance} from './walletConfig';
import {
    BURN_ADDRESS, BUSD_ADDRESS, defaultProviderUrls,
    getTokenPathForBuyingByChain, getTokenPathForSellingByChain,
    provider,
    TOKEN_ABI, uniswap,
} from "../const";
import {erc, getTokenContract, pancakeFactoryTokenInfo, uniswapFactoryTokenInfo} from "./contracts";
import {
    getAmountsOutByChain,
    getChainRouter,
    getCoinAddressByChain,
    getLPAddressByChain, getOwner, getRouterAddressByChain,
    getTokenUSDPair
} from "./index";
import {clearIntervalAsync} from 'set-interval-async/dynamic'
import Timeout from 'await-timeout';
import keccak256 from 'keccak256';
import { Contract, Provider } from 'ethcall';


export const snipeToken = async (data) => {
    let result;
    try {
        result = await snipe(data);
        let statusOfSnipe = '';
        if (result.receipts && result.receipts.length > 0) {
            result.receipts.forEach(receipt => {
                if (receipt.status === 'success') statusOfSnipe = 'success';
            })
        }
        const {receipts} = result;
        if (statusOfSnipe === 'success') {
            return {
                receipts,
                status: 'success',
                reason: 'null'
            }
        } else {
            return {
                receipts,
                status: 'fail',
                reason: result.reason,
            }
        }
    } catch (e) {
        console.log("snipe token ProgramError: ", e);
    }
}

export const approveTokensForSell = async (tokenAddress, selectedChain, provider) => {
    let {account} = getAccount(selectedChain, provider);
    const tokenContract = getTokenContract(tokenAddress, account);
    let approvalReceipt;
    const routerAddress = getRouterAddressByChain(selectedChain);
    try {
        const approval = await tokenContract.approve(routerAddress, ethers.constants.MaxUint256);
        approvalReceipt = await approval.wait();
        if (approvalReceipt.transactionHash) {
            return;
        }
    } catch (e) {
        alert('An error occured approving the tokens... Please contact the dev.')
    }

}

export const getLiquidity = async (tokenAddress, selectedChain, liquidityInterval, selectedToken) => {
    let lpAddress, getLpAddress;
    let liquidity = '0.0';
    let factoryContract;
    if (selectedChain === uniswap) {
        factoryContract = uniswapFactoryTokenInfo;
    } else {
        factoryContract = pancakeFactoryTokenInfo;
    }
    const coinAddress = getCoinAddressByChain(selectedChain, selectedToken);
    getLpAddress = await factoryContract.functions.getPair(tokenAddress, coinAddress);
    lpAddress = getLpAddress[0].toLowerCase();
    if (lpAddress === '0x0000000000000000000000000000000000000000') {
        return liquidity;
    }
    const {account} = getAccount(selectedChain);
    const pairBNBvalue = await erc(account, coinAddress).balanceOf(lpAddress);

    liquidity = ethers.utils.formatEther(pairBNBvalue);
    if (liquidity !== '0.0' && Number(liquidity) > 0.0) {
        clearIntervalAsync(liquidityInterval)
    }
    return liquidity;
}

export const isTradingStillDisabled = async (apikey, selectedAbiFunction, tokenAddress, selectedChain) => {
    const targetCa = new ethers.Contract(tokenAddress, TOKEN_ABI, provider(selectedChain))
    let ownerAddress = await getOwner(targetCa);
    const bscApiUrl = `https://api.bscscan.com/api?module=account&action=txlist&address=${ownerAddress}&startblock=0&endblock=99999999&offset=10&sort=desc&apikey=${apikey}`;
    const data = await fetch(bscApiUrl).then(async res => await res.json()).catch(e => console.log(e));
    const methodId = '0x' + keccak256(selectedAbiFunction).toString('hex');
    const slicedMethodId = methodId.slice(0, 10);
    if(data && data.result && data.result[0] && data.result[0].input && data.result[0].input.slice(0, 10) === slicedMethodId){
        return false;
    }
    return true;
}


const snipe = async (tokenData) => {
    const {
        bnbAmountToSnipe,
        slippage,
        maxGas,
        gwei,
        tokenAddress,
        selectedOption,
        tokenInfo,
        selectedSellOption,
        selectedChain,
        defaultProvider,
        buyTimes,
        selectedToken,
        sellTimes,
        blockDelay,
    } = tokenData;
    const BNBAmount = ethers.utils.parseEther(bnbAmountToSnipe).toHexString();
    const gasPrice = ethers.utils.parseUnits(gwei, 'gwei');
    const gas = {
        gasPrice,
        gasLimit: maxGas
    }
    let account, wallet;
    if (!defaultProviderUrls.includes(defaultProvider)) {
        account = getAccount(selectedChain, defaultProvider).account;
        wallet = getAccount(selectedChain, defaultProvider).wallet;
    } else {
        account = getAccount(selectedChain).account;
        wallet = getAccount(selectedChain).wallet;
    }

    const tokenContract = getTokenContract(tokenAddress, account);

    const router = getChainRouter(selectedChain, account);

    const isBusd = selectedToken.toLowerCase() === 'busd'

    const tokenPathForBuying = isBusd ? [BUSD_ADDRESS, tokenAddress] : getTokenPathForBuyingByChain(selectedChain, tokenAddress);
    const tokenPathForSelling = getTokenPathForSellingByChain(selectedChain, tokenAddress);

    const delaySnipeMs = Number(blockDelay) * 3000;

    let tx, receipt;
    let receipts = [];
    try {
        if (selectedOption === 'buy') {
            await Timeout.set(delaySnipeMs);
            for (let i = 0; i < buyTimes; i++) {
                if (isBusd) {
                    tx = await router.swapExactTokensForTokensSupportingFeeOnTransferTokens(
                        BNBAmount,
                        slippage,
                        tokenPathForBuying,
                        wallet.address,
                        Math.floor(Date.now() / 1000) + 60 * 10, // 10 minutes from now
                        {
                            ...gas,
                        }
                    );
                    try {
                        receipt = await tx.wait();
                        receipt = {...receipt, status: 'success'}
                        receipts.push(receipt);
                    } catch (e) {
                        console.log("tx failure: ", e);
                        receipt = {...receipt, e, status: 'fail'}
                        receipts.push(receipt);
                    }
                } else {
                    tx = await router.swapExactETHForTokensSupportingFeeOnTransferTokens(
                        slippage,
                        tokenPathForBuying,
                        wallet.address,
                        Math.floor(Date.now() / 1000) + 60 * 5, // 10 minutes from now
                        {
                            ...gas,
                            value: BNBAmount,
                        }
                    );
                    try {
                        receipt = await tx.wait();
                        receipt = {...receipt, status: 'success'}
                        receipts.push(receipt);
                    } catch (e) {
                        console.log("tx failure: ", e);
                        receipt = {...receipt, e, status: 'fail'}
                        receipts.push(receipt);
                    }
                }
            }
            return {receipts};
        } else {
            let numberSelectedSellOption = Number(selectedSellOption);
            const decimals = Number(await tokenContract.functions.decimals());
            const calculatedAmountIn = (Number(tokenInfo.balances.tokenBalance) * (numberSelectedSellOption / 100)) / Number(sellTimes);
            const amountIn = ethers.utils.parseUnits(Math.floor(calculatedAmountIn).toString(), decimals);
            const amounts = await router.getAmountsOut(amountIn, tokenPathForSelling)
            let amountOutMin = amounts[1].sub(amounts[1].mul(slippage).div(100));
            for (let i = 0; i < sellTimes; i++) {
                tx = await router.swapExactTokensForETHSupportingFeeOnTransferTokens(
                    amountIn,
                    amountOutMin,
                    tokenPathForSelling,
                    wallet.address,
                    Math.floor(Date.now() / 1000) + 60 * 5, // 10 minutes from now
                    {
                        ...gas,
                    }
                );
                try {
                    receipt = await tx.wait();
                    receipt = {...receipt, status: 'success'}
                    receipts.push(receipt);
                } catch (e) {
                    console.log("tx failure: ", e);
                    receipt = {...receipt, e, status: 'fail'}
                    receipts.push(receipt);
                }
            }
            return {receipts};
        }
    } catch (e) {
        console.log(" router.swapExactETHForTokensProgramError: ", e);
        if (e.toString().includes('intrinsic gas')) {
            return {status: 'fail', reason: 'maxGas'}
        }
        if (e.toString().includes('transaction underpriced')) {
            return {status: 'fail', reason: 'gwei'}
        }
        if (e.toString().includes('insufficient funds')) {
            return {status: 'fail', reason: 'funds'}
        }
        if (e.toString().includes('INSUFFICIENT_INPUT_AMOUNT')) {
            return {status: 'fail', reason: 'insufficient_tokens'}
        }
        return {status: 'fail'};
    }
}

export const getTokenInfo = async (tokenAddress, selectedChain) => {

    const ethcallProvider = new Provider();
    await ethcallProvider.init(provider(selectedChain));

    const tokenContract = new Contract(tokenAddress, TOKEN_ABI);

    const getTokenPairByChain = await getTokenUSDPair(selectedChain);

    const tokenUSDPair = getTokenPairByChain;
    const decimals = tokenContract.decimals();
    const name = tokenContract.name();
    const symbol = tokenContract.symbol();
    const getTotalSupply = tokenContract.totalSupply();
    const getBurnedSupply = tokenContract.balanceOf(BURN_ADDRESS);
    const walletAddress = await getAccount(selectedChain).wallet.address;
    const userTokenBalance = tokenContract.balanceOf(walletAddress);

    const data = await ethcallProvider.all([decimals, name, symbol, getTotalSupply, getBurnedSupply,userTokenBalance]);
    const numberDecimals = Number(data[0]);
    const calculateTotalSupply = Number(data[3]) / 10 ** data[0];
    const calculateBurnAmount = Number(data[4]) / 10 ** data[0];

    let token = {
        name: data[1],
        decimals: numberDecimals,
        symbol: data[2],
        ownerAddress: '',
        lpAddress: '',
        price: {},
        marketCap: {},
        balances: {},
    };

    const coinPrice = (tokenUSDPair.amounts[1]._hex.toString() / 10 ** 18);

    token.totalSupply = calculateTotalSupply
    token.burnAmount = calculateBurnAmount;
    token.circulatingSupply = token.totalSupply - token.burnAmount;


    let amountOutBnb = [0, 0];
    const tokenBalanceConverted = data[5].toString();
    let lpAddress;
    let lpAvailable = true;
    try {
        lpAddress = await getLPAddressByChain(selectedChain, tokenAddress);
        token.lpAddress = lpAddress[0].toLowerCase();
        amountOutBnb = await getAmountsOutByChain(selectedChain, data[0], tokenAddress);
    } catch (e) {
        lpAvailable = false;
    }
    if (lpAvailable) {
        token.price.bnb = amountOutBnb.amounts[1]._hex.toString() / Math.pow(10, 18);
        token.price.usd = token.price.bnb * coinPrice;
        token.price.token = (token.price.usd * tokenBalanceConverted) / Math.pow(10, token.decimals)
        token.marketCap.usd = token.price.usd * token.circulatingSupply;

        token.price.token = (Math.round(token.price.token * 100) / 100).toFixed(2);
        token.price.bnbValueOfTokens = (token.price.token / coinPrice).toFixed(3);

        token.balances.tokenBalance = (await getTokenBalance(tokenAddress, selectedChain)).targetTokenBalance;
    }
    token.balances.bnbBalance = await getWalletBalance(selectedChain);

    return token;
}